import { render } from "./ModalConfirmPermissions.vue?vue&type=template&id=aa54fb8e"
import script from "./ModalConfirmPermissions.vue?vue&type=script&lang=js"
export * from "./ModalConfirmPermissions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__